// import React, { useState } from 'react';
// import {
//     BarChart,
//     Bar,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     Legend,
//     ResponsiveContainer,
//     Cell
// } from 'recharts';
// import GraphModal from '../graphModal/GraphModal';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import FilterBadge from '../common/FilterBadge';
// import './stackedBarChart.scss';
// import Skeleton from "@mui/material/Skeleton";
// import { monthColorMap, StackedBarChartType, subjectColorMap } from '../../enum';
// import CustomLegend from './CustomLegend';

// const StackedBarChart = ({ title, data, subjectKeys, loading, appliedFilters = [], chartType = StackedBarChartType.ATTENDANCE }) => {
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [showFilters, setShowFilters] = useState(false);
//     const hasFilters = appliedFilters.length > 0 && !loading;

//     const handleOpenModal = () => setIsModalOpen(true);
//     const handleCloseModal = () => setIsModalOpen(false);

//     const getColor = (monthLabel) => {
//         if (chartType === StackedBarChartType.ATTENDANCE) {
//             // Extract month name from "Jan 2025"
//             const month = monthLabel.split(" ")[0];
//             return monthColorMap[month] || "#cccccc"; // fallback color
//         }
//         // Extract month name from "Jan 2025"
//         // const subject = monthLabel.split(" ")[0];
//         return subjectColorMap[monthLabel] || "#cccccc"; // fallback color
//     };

//     // Calculate overall average for each student
//     const enhancedData = data.map(student => {
//         let total = 0;
//         let count = 0;

//         subjectKeys.forEach(subject => {
//             if (student[subject] !== undefined) {
//                 total += student[subject];
//                 count++;
//             }
//         });

//         return {
//             ...student,
//             overall: count > 0 ? total / count : 0
//         };
//     });

//     const sortedData = [...enhancedData].sort((a, b) => {
//         return b.overall - a.overall;
//     });

//     // ✅ Now safe to use sortedData here
//     const longestNameLength =
//         sortedData.length > 0 ? Math.max(...sortedData.map(d => d.name.length)) : 0;

//     const xAxisFontSize = Math.max(10, 14 - Math.floor(longestNameLength / 6));

//     // Custom tooltip formatter
//     // const CustomTooltip = ({ active, payload, label }) => {
//     //     if (active && payload && payload.length) {
//     //         // Calculate overall average excluding the "Overall" entry if present
//     //         const validEntries = payload.filter(entry => entry.name !== 'Overall');
//     //         const overallAverage = validEntries.reduce((sum, entry) => sum + entry.value, 0) / validEntries.length;

//     //         return (
//     //             <div className="stacked-bar-tooltip">
//     //                 <p className="student-name">{label}</p>
//     //                 <div className="subject-scores">
//     //                     {payload.map((entry, index) => (
//     //                         <p key={index} style={{ color: entry.color }}>
//     //                             <span className="subject-label">{entry.name}:</span>
//     //                             <span className="subject-value">{entry.value.toFixed(2)}%</span>
//     //                         </p>
//     //                     ))}
//     //                 </div>
//     //                 <div className="overall-score">
//     //                     <span className="overall-label">Overall Average:</span>
//     //                     <span className="overall-value">{overallAverage.toFixed(2)}%</span>
//     //                 </div>
//     //             </div>
//     //         );
//     //     }
//     //     return null;
//     // };

//     const CustomTooltip = ({ active, payload, label }) => {
//         if (active && payload && payload.length) {
//             const validEntries = payload.filter(entry => entry.name !== 'Overall');
//             const overallAverage = validEntries.reduce(
//                 (sum, entry) => sum + entry.value,
//                 0
//             ) / validEntries.length;

//             // 📌 Dynamic font size scaling
//             const subjectCount = validEntries.length;
//             const baseFontSize = 16; // default
//             const minFontSize = 12;  // smallest allowed
//             const fontSize = Math.max(minFontSize, baseFontSize - subjectCount * 0.3);

//             return (
//                 <div
//                     className="stacked-bar-tooltip"
//                     style={{ fontSize: `${fontSize}px` }} // 👈 applied globally
//                 >
//                     <p className="student-name">{label}</p>
//                     <div className="subject-scores">
//                         {payload.map((entry, index) => (
//                             <p key={index} style={{ color: entry.color }}>
//                                 <span className="subject-label">{entry.name}:</span>
//                                 <span className="subject-value">
//                                     {entry.value.toFixed(2)}%
//                                 </span>
//                             </p>
//                         ))}
//                     </div>
//                     {/* <div className="overall-score">
//                         <span className="overall-label">Overall Average:</span>
//                         <span className="overall-value">
//                             {overallAverage.toFixed(2)}%
//                         </span>
//                     </div> */}
//                 </div>
//             );
//         }
//         return null;
//     };



//     const renderLegend = (
//         <CustomLegend
//             subjectKeys={subjectKeys}
//             getColor={getColor}
//             chartType={StackedBarChartType.RESULTS}
//         />
//     );

//     return (
//         <div
//             className="stackedBarChartContainer"
//             onMouseEnter={() => setShowFilters(true)}
//             onMouseLeave={() => setShowFilters(false)}
//         >
//             <div className="chart-header">
//                 <h2 className="chartTitle">{title}</h2>
//                 {hasFilters && (
//                     <div className="filter-indicator">
//                         <FilterListIcon fontSize="small" />
//                     </div>
//                 )}
//             </div>

//             {hasFilters && showFilters && (
//                 <div className="filter-tooltip">
//                     <div className="filter-header">Applied Filters:</div>
//                     <div className="filter-badges">
//                         {appliedFilters.map((filter, index) => (
//                             <FilterBadge
//                                 key={index}
//                                 label={filter.label}
//                                 value={filter.value}
//                             />
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {loading ? (
//                 <Skeleton
//                     variant="rectangular"
//                     width="100%"
//                     height={400}
//                     animation="wave"
//                     className="chart-skeleton"
//                 />
//             ) : sortedData.length > 0 ? (
//                 <>
//                     {/* Legend container positioned above the chart */}
//                     {/* <div className="legend-container">
//                         <div className="custom-legend">
//                             {subjectKeys.map((subject, index) => (
//                                 <div key={subject} className="legend-item">
//                                     <div
//                                         className="legend-color"
//                                         style={{ backgroundColor: getColor(subject) }}
//                                     />
//                                     <span className="legend-label">{subject}</span>
//                                 </div>
//                             ))}
//                             <div className="legend-item">
//                                 <div
//                                     className="legend-color"
//                                     style={{
//                                         backgroundColor: '#000000'
//                                     }}
//                                 />
//                                 <span className="legend-label">Overall</span>
//                             </div>
//                         </div>
//                     </div> */}
//                     {renderLegend}


//                     {/* Main chart - clickable */}
//                     <div className="chart-wrapper" onClick={handleOpenModal}>
//                         <ResponsiveContainer width="100%" height={450}>
//                             <BarChart
//                                 data={sortedData}
//                                 margin={{ top: 20, right: 30, left: 20, bottom: 50 }}
//                                 barGap={10}
//                                 barCategoryGap={20}
//                             >
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 {/* <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} /> */}
//                                 <XAxis
//                                     dataKey="name"
//                                     angle={-30}
//                                     textAnchor="end"
//                                     height={80}
//                                     tick={{ fontSize: xAxisFontSize }}
//                                     interval={0}
//                                 />
//                                 <YAxis domain={[0, 100]} />
//                                 <Tooltip content={<CustomTooltip />} />
//                                 {subjectKeys.map((subject, index) => (
//                                     <Bar
//                                         key={subject}
//                                         dataKey={subject}
//                                         fill={getColor(subject)}
//                                         name={subject}
//                                         barSize={30}
//                                     />
//                                 ))}
//                                 <Bar
//                                     dataKey="overall"
//                                     name="Overall"
//                                     fill="#000000"
//                                     barSize={30}
//                                 />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </div>

//                     <GraphModal isOpen={isModalOpen} onClose={handleCloseModal} title={title} additionalContent={renderLegend}>
//                         <ResponsiveContainer width="100%" height={500}>
//                             <BarChart
//                                 data={sortedData}
//                                 margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
//                                 barGap={20}
//                                 barCategoryGap={20}
//                             >
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 {/* <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} /> */}
//                                 <XAxis
//                                     dataKey="name"
//                                     angle={-30}
//                                     textAnchor="end"
//                                     height={100}
//                                     tick={{ fontSize: xAxisFontSize + 2 }}
//                                     interval={0}
//                                 />

//                                 <YAxis domain={[0, 100]} />
//                                 <Tooltip content={<CustomTooltip />} />
//                                 {subjectKeys.map((subject, index) => (
//                                     <Bar
//                                         key={subject}
//                                         dataKey={subject}
//                                         fill={getColor(subject)}
//                                         name={subject}
//                                         barSize={50}
//                                     />
//                                 ))}
//                                 <Bar
//                                     dataKey="overall"
//                                     name="Overall"
//                                     fill="#000000"
//                                     barSize={50}
//                                 />
//                             </BarChart>
//                         </ResponsiveContainer>
//                     </GraphModal>
//                 </>
//             ) : (
//                 <div className="no-data">No data available for selected filters</div>
//             )}
//         </div>
//     );
// };

// export default StackedBarChart;


import React, { useState } from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';
import GraphModal from '../graphModal/GraphModal';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterBadge from '../common/FilterBadge';
import './stackedBarChart.scss';
import Skeleton from "@mui/material/Skeleton";
import { monthColorMap, StackedBarChartType, subjectColorMap } from '../../enum';
import CustomLegend from './CustomLegend';

const StackedBarChart = ({ title, data, subjectKeys, loading, appliedFilters = [], chartType = StackedBarChartType.ATTENDANCE }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const hasFilters = appliedFilters.length > 0 && !loading;

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const getColor = (monthLabel) => {
        if (chartType === StackedBarChartType.ATTENDANCE) {
            const month = monthLabel.split(" ")[0];
            return monthColorMap[month] || "#cccccc";
        }
        return subjectColorMap[monthLabel] || "#cccccc";
    };

    // Calculate overall average for each student
    const enhancedData = data.map(student => {
        let total = 0;
        let count = 0;

        subjectKeys.forEach(subject => {
            if (student[subject] !== undefined) {
                total += student[subject];
                count++;
            }
        });

        return {
            ...student,
            overall: count > 0 ? total / count : 0
        };
    });

    const sortedData = [...enhancedData].sort((a, b) => {
        return b.overall - a.overall;
    });

    const longestNameLength =
        sortedData.length > 0 ? Math.max(...sortedData.map(d => d.name.length)) : 0;

    const xAxisFontSize = Math.max(10, 14 - Math.floor(longestNameLength / 6));

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const validEntries = payload.filter(entry => entry.name !== 'Overall');
            const overallAverage = validEntries.reduce(
                (sum, entry) => sum + entry.value,
                0
            ) / validEntries.length;

            const subjectCount = validEntries.length;
            const baseFontSize = 16;
            const minFontSize = 12;
            const fontSize = Math.max(minFontSize, baseFontSize - subjectCount * 0.3);

            return (
                <div className="stacked-bar-tooltip" style={{ fontSize: `${fontSize}px` }}>
                    <p className="student-name">{label}</p>
                    <div className="subject-scores">
                        {payload.map((entry, index) => (
                            <p key={index} style={{ color: entry.color }}>
                                <span className="subject-label">{entry.name}:</span>
                                <span className="subject-value">{entry.value.toFixed(2)}%</span>
                            </p>
                        ))}
                    </div>
                </div>
            );
        }
        return null;
    };

    const renderLegend = (
        <CustomLegend
            subjectKeys={subjectKeys}
            getColor={getColor}
            chartType={StackedBarChartType.RESULTS}
        />
    );

    return (
        <div
            className="stackedBarChartContainer"
            onMouseEnter={() => setShowFilters(true)}
            onMouseLeave={() => setShowFilters(false)}
        >
            <div className="chart-header">
                <h2 className="chartTitle">{title}</h2>
                {hasFilters && (
                    <div className="filter-indicator">
                        <FilterListIcon fontSize="small" />
                    </div>
                )}
            </div>

            {hasFilters && showFilters && (
                <div className="filter-tooltip">
                    <div className="filter-header">Applied Filters:</div>
                    <div className="filter-badges">
                        {appliedFilters.map((filter, index) => (
                            <FilterBadge
                                key={index}
                                label={filter.label}
                                value={filter.value}
                            />
                        ))}
                    </div>
                </div>
            )}

            {loading ? (
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={400}
                    animation="wave"
                    className="chart-skeleton"
                />
            ) : sortedData.length > 0 ? (
                <>
                    {renderLegend}
                    <div className="chart-wrapper" onClick={handleOpenModal}>
                        <ResponsiveContainer width="100%" height={450}>
                            <BarChart
                                data={sortedData}
                                margin={{ top: 20, right: 30, left: 20, bottom: 30 }} // Reduced bottom margin
                                barGap={10}
                                barCategoryGap={20}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="name"
                                    angle={-30}
                                    textAnchor="end"
                                    height={60} // Reduced height to minimize padding
                                    tick={{ fontSize: xAxisFontSize }}
                                    tickMargin={5} // Adjust tick margin to pull labels closer
                                    interval={0}
                                />
                                <YAxis domain={[0, 100]} />
                                <Tooltip content={<CustomTooltip />} />
                                {subjectKeys.map((subject, index) => (
                                    <Bar
                                        key={subject}
                                        dataKey={subject}
                                        fill={getColor(subject)}
                                        name={subject}
                                        barSize={30}
                                    />
                                ))}
                                <Bar
                                    dataKey="overall"
                                    name="Overall"
                                    fill="#000000"
                                    barSize={30}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>

                    <GraphModal isOpen={isModalOpen} onClose={handleCloseModal} title={title} additionalContent={renderLegend}>
                        <ResponsiveContainer width="100%" height={500}>
                            <BarChart
                                data={sortedData}
                                margin={{ top: 0, right: 0, left: 0, bottom: 20 }} // Reduced bottom margin
                                barGap={20}
                                barCategoryGap={20}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="name"
                                    angle={-30}
                                    textAnchor="end"
                                    height={70} // Reduced height for modal
                                    tick={{ fontSize: xAxisFontSize + 2 }}
                                    tickMargin={5} // Adjust tick margin
                                    interval={0}
                                />
                                <YAxis domain={[0, 100]} />
                                <Tooltip content={<CustomTooltip />} />
                                {subjectKeys.map((subject, index) => (
                                    <Bar
                                        key={subject}
                                        dataKey={subject}
                                        fill={getColor(subject)}
                                        name={subject}
                                        barSize={50}
                                    />
                                ))}
                                <Bar
                                    dataKey="overall"
                                    name="Overall"
                                    fill="#000000"
                                    barSize={50}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </GraphModal>
                </>
            ) : (
                <div className="no-data">No data available for selected filters</div>
            )}
        </div>
    );
};

export default StackedBarChart;